import { faChessKing } from "@fortawesome/pro-regular-svg-icons";
import FontAwesomeButton, {
  ButtonIcon,
} from "components/Button/FontAwesomeButton";
import React from "react";

import { useSelector } from "react-redux";

import { getIsStaff } from "selectors";

interface AdminLinkProps {
  model: string;
  app?: string;
  cbid?: string;
  id?: number;
  queryParams?: { key: string; value: string }[];
  disabled?: boolean;
}

export const AdminLink: React.FC<AdminLinkProps> = ({
  model,
  app = "agrinous",
  cbid,
  id,
  queryParams = [],
  disabled = false,
}) => {
  const hideAdminLinks = localStorage.getItem("_hide_admin_links") === "yes";

  const isStaff = useSelector(getIsStaff);

  if (!isStaff || hideAdminLinks) {
    return null;
  }

  const buildAdminUrl = (): string => {
    const baseUrl = window.location.origin;
    let adminPath = `/admin/${app}/${model}/`;

    if (id) {
      adminPath += `${id}/change/`;
    } else if (cbid) {
      queryParams.push({ key: "cbid", value: cbid });
    }

    const searchParams = new URLSearchParams();
    queryParams.forEach(({ key, value }) => {
      searchParams.append(key, value);
    });

    const queryString = searchParams.toString();
    const fullUrl = `${baseUrl}${adminPath}${queryString ? `?${queryString}` : ""}`;

    return fullUrl;
  };

  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    const adminUrl = buildAdminUrl();
    window.open(adminUrl, "_blank", "noopener,noreferrer");
  };

  return (
    <FontAwesomeButton
      type="button"
      onClick={handleClick}
      size={1}
      background="transparent"
      margin={3}
      padding="3px"
      display="inline-block"
      vertical-align="middle"
      border="none"
      disabled={disabled}
    >
      <ButtonIcon icon={faChessKing} color="primary" />
    </FontAwesomeButton>
  );
};
